import React from 'react';
import { Box, Stack } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import IntroCard from '../common/IntroCard';

const IHero = () => (
  <Box
    flexDirection="row"
    justifyContent="center"
    alignItems="center"
    maxW={{ base: 'xl', desktop: '8xl' }}
    w="100%"
    mx="auto"
    py="100px"
  >
    <Stack flexDir="column" gap={{ base: 7, desktop: 16 }} alignItems="center">
      <IntroCard
        color="#3b77bc"
        description="CompanyCam is an innovative way for home improvement professionals to organize, sync, and share photos based on job location."
        logo={
          <StaticImage
            src="../../../assets/images/partners/integrations/3.png"
            alt="CompanyCam"
          />
        }
        position="unset"
      />
      <IntroCard
        color="#e12d2c"
        description="CoreLogic is a leading provider of consumer, financial and property data, analytics and services to business and government."
        logo={
          <StaticImage
            src="../../../assets/images/partners/integrations/4.svg"
            alt="CoreLogic"
          />
        }
        position="unset"
      />
      <IntroCard
        color="#3c60a9"
        description="JobNimbus helps businesses track leads, manage jobs, and complete tasks from anywhere in the world."
        logo={
          <StaticImage
            src="../../../assets/images/partners/integrations/9.svg"
            alt="JobNimbus"
          />
        }
        position="unset"
      />
    </Stack>
    <Box d={{ base: 'none', desktop: 'block' }}>
      <StaticImage
        src="../../../assets/images/partners/integrations/partners_integration_hero.jpg"
        alt=""
      />
    </Box>
  </Box>
);

export default IHero;
